import styled from '@emotion/styled';

interface Props {
    totalCount: number;
    index: number;
    right?: number;
    bottom?: number;
}

function BannerCounter({
    totalCount, index, right, bottom,
}:Props) {
    return (
        <Container right={right} bottom={bottom}>
            {index + 1} | {totalCount}
        </Container>
    );
}

const Container = styled.div<{
    right?: number;
    bottom?: number;
}>`
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 4px 0 8px 0;
    padding: 4px 8px;
    font-size: 10px;
    line-height: 1.4;
    font-weight: 500;
    position: absolute;
    right: ${(props) => props.right || 0}px;
    bottom: ${(props) => props.bottom || 0}px;
    color: white;
    z-index: 2;
`;

export default BannerCounter;
